import { Component } from '@angular/core';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { MatTableDataSource, MatTableModule} from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { ClientBusinessDetail } from '../Models/Response';
import { ToastrService } from 'ngx-toastr';
import { AppComponent } from 'src/app/app.component'; 
@Component({
  selector: 'app-manager-dashboard',
  templateUrl: './manager-dashboard.component.html',
  styleUrls: ['./manager-dashboard.component.css']
})
export class ManagerDashboardComponent {
  UserId: string = "";
  // BusinessInfo:any;
  // BusinessInfoData:any;
  ManagerClientDataInfo:any;
  ClientProfileName: string = "";
  BusinessProfileName: string = "";
  ManagerNameAsPhoto: string = "";
  ManagerName: string = "";
  ClientUserId: string = "";
  BusinessInfoId: string = "";
  ManagerClientData: ClientBusinessDetail[]=[];
  getSafeValue(value: string | null): string {
    return (value === null || value === "undefined") ? "" : value;
  }
  ngOnInit(): void {
    this.UserId = this.getSafeValue(localStorage.getItem("UserId"));
    this.ManagerName = this.getSafeValue(localStorage.getItem("ManagerName"));
    this.ManagerNameAsPhoto = `${Array.from(this.ManagerName)[0]}`;
    // this.BusinessInfo = this.getSafeValue(localStorage.getItem("BusinessInfo"));
    this.ClientProfileName = this.getSafeValue(localStorage.getItem("ClientProfileName"));
    this.BusinessProfileName = this.getSafeValue(localStorage.getItem("BusinessProfileName"));
    this.service.NewClientsWithBusinessDetails(this.UserId).subscribe(data => {
      if (data.Code == 200) {
        this.ManagerClientData=data.ClientBusinessDetails;
        // this.ManagerClientData.forEach((element,i) => {
        //   element.UserImageText = Array.from(element.ClientFirstName)[0] + "" + Array.from(element.ClientLastName)[0];
        // })
        this.ManagerClientData.forEach(element=> {
          element.ClientFullName = element.ClientFirstName + ' ' + element.ClientLastName;
          element.ManagerImageText= `${Array.from(element.ClientFullName)[0]}`;
        });
        
        // this.UserNameAsPhoto = `${Array.from(this.FirstName)[0]}`;
        // this.dataSource = new MatTableDataSource(this.ManagerClientData);
      } else {
      }
    });

  }
  private showSuccess(message: string): void {
    this.toastr.success(message, 'Success', {
      toastClass: 'ngx-toastr toast-success'
    });
  }
  private showError(message: string): void {
    this.toastr.error(message, 'Error', {
      toastClass: 'ngx-toastr toast-error'
    });
  }

  onSwitch(i: number) {
    if (this.ManagerClientData && this.ManagerClientData.length > i) {
      this.showSuccess('Switched to Client Business Successful');
      this.ManagerClientDataInfo = this.ManagerClientData[i];
      this.ClientProfileName = this.ManagerClientDataInfo.ClientFullName;
      localStorage.setItem("ClientProfileName",""+ this.ClientProfileName);
      this.BusinessProfileName = this.ManagerClientDataInfo.BusinessInfo_BusinessName;
      localStorage.setItem("BusinessProfileName",""+ this.BusinessProfileName);
      // this.UserNameAsPhoto = `${Array.from(this.ProfileName)[0]}`; 
      this.ClientUserId = this.ManagerClientDataInfo.ClientUserId;
      localStorage.setItem("ClientUserId",""+ this.ClientUserId);
      this.BusinessInfoId = this.ManagerClientDataInfo.BusinessInfoId;
      localStorage.setItem("BusinessInfoId",""+ this.BusinessInfoId);

      // window.location.reload();
    } else {
      console.error("Invalid business index or BusinessInfoData is undefined");
      this.showError('Failed to Switch Client Business . Please check your selection.');
    }
  }
  
  
  screenWidth: any;
  screenHeight: any;
  isManagerExpanded = false;

  toggleManagerSidebar() {
    this.isManagerExpanded = !this.isManagerExpanded;
  }
  isSecondSidebarManagerExpanded: boolean = false; // Second sidebar state

  toggleSecondManagerSidebar() {
    this.isSecondSidebarManagerExpanded = !this.isSecondSidebarManagerExpanded;
  }

  constructor(public service: SharkifyAiSerivceService,private toastr: ToastrService,
    public app: AppComponent) {
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    };
  }
}


